module.exports = __webpack_public_path__ + "fonts/nunito-sans-latin-200italic.d5dc95c.woff";